module.exports = __webpack_public_path__ + "img/1-3.61ec67b2.svg";